module.exports = __webpack_public_path__ + "media/memory-bank/levelnew-avatar-25ec6d89.png";